<template>
  <el-upload
    :action="action"
    :headers="{sessionId}"
    :accept="accept"
    :show-file-list="false"
    :before-upload="handleBeforeUpload"
    :on-progress="handleProgress"
    :on-success="handleSuccess"
    :on-error="handleError"
    :data="params"
    :disabled="disabled"
    style="display: inline-block"
  >
    <el-button :disabled="disabled" type="primary" @click="onClick">{{ title }}</el-button>
  </el-upload>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import lang from '@/lang'

export default {
  name: 'CargoSimpleUpload',
  props: {
    title: {
      type: String,
      default: () => lang.t('Message.ImportFile')
    },
    action: {
      type: String,
      default: () => ''
    },
    accept: {
      type: String,
      default: () => ''
    },
    fileType: {
      type: Array,
      default: () => null
    },
    params: {
      type: Object,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkCallback: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      loading: null
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    }
  },
  methods: {
    onClick(e) {
      if (typeof this.checkCallback === 'function') {
        if (!this.checkCallback()) {
          e.stopPropagation()
        }
      }
    },
    handleBeforeUpload(file) {
      console.log(file)
      let canUpload = true
      if (this.fileType) {
        canUpload = false
        this.fileType.forEach(item => {
          if (file.type) {
            if (file.type.includes(item)) {
              canUpload = true
            }
          } else {
            if (file.name.toLowerCase().includes(item)) {
              canUpload = true
            }
          }
        })
      }
      if (!canUpload) {
        this.$message.error(this.$t('Message.Only0FormatCanUploaded', [this.accept]))
        return canUpload
      }
      if (!file.size) {
        this.$message.error(`${file.name}文件体积异常,不能进行上传.`)
        return false
      }
      if (file.size && file.size > 20 * 1024 * 1024) {
        this.$message.error(`${file.name}文件体积超过20M,不能进行上传.`)
        return false
      }
      return true
    },
    handleProgress() {
      this.loading = getLoading()
    },
    handleSuccess(response) {
      this.$message.success(`上传成功`)
      this.$emit('success', response)
      this.loading.close()
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    }
  }
}
</script>

<style scoped>

</style>
